// extracted by mini-css-extract-plugin
export default {"content":"sticky-header_content__mBsrj","stickyMenuAnimation":"sticky-header_stickyMenuAnimation__-JgNR","hidden":"sticky-header_hidden__2jiUH"};